import { Box, styled } from '@mui/material';

export const TemplateIframeWrapper = styled('div')({
  height: '650px',
  overflow: 'hidden',
  position: 'relative',
  transition: 'opacity 0.5s ease-in-out',
  marginTop: '30px',
  border: '2px solid #ecedf0',
  borderRadius: '5px',
  display: 'flex',

  '&.loading': {
    opacity: 0,
    transition: 'opacity 0.5s ease-in-out'
  },

  iframe: {
    border: 'none',
    position: 'absolute',
    width: '894px',
    top: 0
  }
});

export const TemplateSubjectWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  marginTop: '20px'
});

export const TemplateBodyWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  marginTop: '20px'
});

export const ErrorMessage = styled(Box)({
  color: '#E25650',
  marginLeft: '15px',
  fontSize: '15px'
});
